import { useLocation } from "react-router-dom";
import { ComingSoonIcon } from "../../assets/icons";
import LayoutWrapper from "../../layouts/landing-page-layout-wrapper/layoutWrapper";
import styles from "./comingSoon.module.scss";
import { useEffect } from "react";

const ComingSoonPage = () => {
	const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

	return (
		<LayoutWrapper>
			<div className={styles.container}>
				<ComingSoonIcon className={styles.icon} />
			</div>
		</LayoutWrapper>
	);
};
export default ComingSoonPage;
